<template>
	<CarbarButton
		v-bind="$attrs"
		class=""
		:class="[]"
		:is-outline="isOutline"
		:is-mixed="isMixed"
		:is-full-width="isFullWidth"
		:border="border"
		:border-color="borderColor"
		:background-color="backgroundColor"
		:text-color="textColor"
		:shadow="shadow"
		:width="width"
		:min-width="minWidth"
		@click="onClick"
	>
		<slot></slot>
	</CarbarButton>
</template>

<script setup>
import CarbarButton from '@/components/buttons/CarbarButton.vue'

const props = defineProps({
	isOutline: {
		type: Boolean,
		default: true,
		required: false,
	},
	isMixed: {
		type: Boolean,
		default: false,
		required: false,
	},
	isFullWidth: {
		type: Boolean,
		default: false,
		required: false,
	},
	backgroundColor: {
		type: String,
		default: 'bg-transparent',
		required: false,
	},
	textColor: {
		type: String,
		default: 'text-gray-600 hover:text-blue-400',
		required: false,
	},
	border: {
		type: String,
		default: 'border',
		required: false,
	},
	borderColor: {
		type: String,
		default: 'border-gray-400 hover:border-blue-300',
		required: false,
	},
	shadow: {
		type: String,
		default: '',
		required: false,
	},
	width: {
		type: String,
		default: 'w-full',
		required: false,
	},
	minWidth: {
		type: String,
		default: 'min-w-full',
		required: false,
	},
})

const emit = defineEmits(['click'])

const onClick = () => {
	emit('click')
}
</script>
